import { isCanadaDomain } from './urlParams';
import { CURRENCY } from '../constants/currency';

export const getCurrency = () =>
  isCanadaDomain() ? CURRENCY.CANADA : CURRENCY.USA;
